import api from '../../utils/axios';
import { useState, useCallback } from 'react';

interface ProveedorItem {
  Id: number;
  IdTipoDocumento: number;
  NumeroIdentificacion: string;
  Nombre: string;
  RepresentanteLegal: string;
  Direccion: string;
  Telefono: string;
  Correo: string;
  Web?: string;
  Activo: boolean;
  Eliminado: boolean;
  tipoDocumento?: {
    Id: number;
    Nombre: string;
  };
}

interface ProveedorDto {
  IdTipoDocumento: number;
  NumeroIdentificacion: string;
  Nombre: string;
  RepresentanteLegal: string;
  Direccion: string;
  Telefono: string;
  Correo: string;
  Web?: string;
  Activo: boolean;
}

interface ApiError {
  response?: {
    data?: {
      message?: string;
    };
  };
  message: string;
}

const useProveedoresApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = '/administracion/proveedores';

  const getAll = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.post<ProveedorItem[]>(`${baseUrl}/findAll`);
      return response.data.filter(item => !item.Eliminado);
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const create = useCallback(async (data: ProveedorDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/create`, data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const update = useCallback(async (id: number, data: ProveedorDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/update/${id}`, data);
      return response.data;
    } catch (err) {
      const error = err as ApiError;
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const remove = useCallback(async (id: number) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/softDelete/${id}`);
      return true;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    getAll,
    create,
    update,
    remove
  };
};

export { useProveedoresApi };
export type { ProveedorItem, ProveedorDto, ApiError };